import React, { useState } from "react";
import ModalBaseView from "../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Modal from "../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as SelectPane from "../../../../../common-deprecated/styles/v2/toyota/custom/SelectPane";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { getEngineName } from "../../../utils/formatters/nameFormatters";
import { CompareV2Label } from "../../../utils/labels";
import type { SelectEngineType } from "../../../../../shared-logic/features/compare/utils/modalConstants";
import { type CompareV2DispatchType, useCompareV2Selector } from "../../../redux/store";
import { compareSetNewEngine } from "../../../redux/actions/NewCarCompareActions";
import type { CompareMotorizationType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { trackCompareEngineSelect } from "../../../utils/tracking";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const ToyotaSelectEngineModal = (props: ModalViewType<SelectEngineType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { index } = modalSettings;
    const dispatch = useDispatch<CompareV2DispatchType>();

    const engines = useCompareV2Selector((state) => state.newCarCompare.specs[index]);
    const selectedEngine = useCompareV2Selector((state) => state.newCarCompare.selectedEngines[index]);
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);

    const [selected, setSelected] = useState<number>(
        engines
            ? engines.findIndex(
                  (e) =>
                      e.wheeldriveId === selectedEngine.wheeldriveId &&
                      e.transmissionId === selectedEngine.transmissionId &&
                      e.engineId === selectedEngine.engineId,
              )
            : 0,
    );

    const makeSelection = (engine: CompareMotorizationType): void => {
        trackCompareEngineSelect(cars[index], engine);
        dispatch(compareSetNewEngine(engine, index));
    };

    const makeSelectionClick = (): void => {
        // Make sure the modal closes before the rerender of the compare
        setTimeout(() => {
            makeSelection(engines[selected]);
        }, 100);
        close();
    };
    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="sm">
            <Modal.Header buttonAlignment="left">
                <Modal.Button type="button" onClick={close} lightBg hasText>
                    <IconWrapper>
                        <Icon variant="arrowLeft" />
                    </IconWrapper>
                    <Text.Button>
                        <CompareV2Label label="compareSelectGradeCancel" />
                    </Text.Button>
                </Modal.Button>
            </Modal.Header>
            <SelectPane.Wrapper>
                <SelectPane.Body>
                    <SelectPane.Panels>
                        <SelectPane.Panel>
                            <SelectPane.PanelScroll>
                                {engines.map((engine, engineIndex) => {
                                    return (
                                        <SelectPane.PanelItem
                                            selected={selected === engineIndex}
                                            onClick={() => setSelected(engineIndex)}
                                            key={engine.engineId + engine.wheeldriveId + engine.transmissionId}
                                        >
                                            <span>{getEngineName(engine)}</span>
                                        </SelectPane.PanelItem>
                                    );
                                })}
                            </SelectPane.PanelScroll>
                        </SelectPane.Panel>
                    </SelectPane.Panels>
                </SelectPane.Body>
                <SelectPane.Footer>
                    <Button.Primary type="button" onClick={makeSelectionClick}>
                        <Text.Button>
                            <CompareV2Label label="compareSelectEngineConfirm" />
                        </Text.Button>
                    </Button.Primary>
                </SelectPane.Footer>
            </SelectPane.Wrapper>
        </ModalBaseView>
    );
};
export default ToyotaSelectEngineModal;
